// TODO better to replace to env variables
export const timepadEventId = 1767674;
export const timepadCustomized = 48942;
export const yandexMetrikaTrackingId = 85714740;
export const fbTrackingId = 938518303402112;
